import { AlarmPlusIcon } from 'lucide-react';
import { validations } from './validations';

/**
 * Questions about beer Behavior patterns and relationship with beer
 */
export const beerBehaviorQuestions = [
  {
    id: 'beer-listening-styles',
    question: 'Ao beber cerveja fora de casa, que estilos de música você prefere ouvir?',
    subtitle: 'Selecione até 3',
    type: 'checkbox',
    options: [
      { value: 'axé', label: 'Axé' },
      { value: 'blues', label: 'Blues' },
      { value: 'clássica', label: 'Clássica' },
      { value: 'eletrônica', label: 'Eletrônica' },
      { value: 'forro', label: 'Forro' },
      { value: 'funk', label: 'Funk' },
      { value: 'jazz', label: 'Jazz' },
      { value: 'metal', label: 'Metal' },
      { value: 'mpb', label: 'MPB' },
      { value: 'pagode', label: 'Pagode' },
      { value: 'pop', label: 'Pop' },
      { value: 'rap', label: 'Rap' },
      { value: 'reggae', label: 'Reggae' },
      { value: 'rock', label: 'Rock' },
      { value: 'samba', label: 'Samba' },
      { value: 'sertanejo', label: 'Sertanejo' },
      { value: 'trap', label: 'Trap' },
    ],
    nextQuestion: 'beer-adquisition-channels',
    minSelections: 1,
    maxSelections: 3,
    validation: validations.checkboxMinMax(1, 3)
  },
  {
    id: 'beer-adquisition-channels',
    question: 'Onde você adquire o que bebe?',
    subtitle: 'selecione até 3 canais mais representativos',
    type: 'sortable',
    options: (allAnswers) => {
      const options = [
        { value: 'aplicativos de entrega', label: 'Aplicativos de entrega' },
        { value: 'bares', label: 'Bares' },
        { value: 'lojas especializadas (ex.: empórios cervejeiros)', label: 'Lojas especializadas (ex.: Empórios cervejeiros' },
        { value: 'direto no site da cervejaria ou de sites especializados', label: 'Direto no site da cervejaria ou de sites especializados' },
        { value: 'fabricação própria', label: 'Fabricação própria' },
        { value: 'indo a brewpubs ou direto na fábrica', label: 'Indo a brewpubs ou direto na fábrica' },
        { value: 'supermercados', label: 'Supermercados' },
        { value: 'adegas / distribuidoras', label: 'Adegas / Distribuidoras' },
        { value: 'whatsapp', label: 'Whatsapp' },
      ];
      if(allAnswers['common-beer'] == 'somente comuns') {
        return options.filter((option) => {
          return (
            option.value !== 'lojas especializadas (ex.: empórios cervejeiros)' &&
            option.value !== 'fabricação própria' &&
            option.value !== 'indo a brewpubs ou direto na fábrica'
          );
        });
      }
      return options;
    },
    minSelections: 1,
    maxSelections: 3,
    validation: validations.sortableMinMax(1, 3),
  },
  {
    id: 'beer-adquisition-considerations',
    question: 'O que você leva em consideração na hora de comprar?',
    subtitle: 'selecione até 3',
    type: 'checkbox',
    options: (allAnswers) => {
      const options = [
        { value: 'compro sempre a que já conheço e gosto', label: 'Compro sempre a que já conheço e gosto' },
        { value: 'busco dicas na internet', label: 'Busco dicas na internet' },
        { value: 'custo x benefício', label: 'Custo x benefício' },
        { value: 'escola/origem (alemã, inglesa, belga, americana)', label: 'Escola/origem (alemã, inglesa, belga, americana)' },
        { value: 'estilo da cerveja', label: 'Estilo da cerveja' },
        { value: 'harmonização com pratos', label: 'Harmonização com pratos' },
        { value: 'lançamentos', label: 'Lançamentos' },
        { value: 'marcas conhecidas', label: 'Marcas conhecidas' },
        { value: 'marcas desconhecidas (desbravando)', label: 'Marcas desconhecidas (desbravando)' },
        { value: 'preço', label: 'Preço' },
        { value: 'prêmio / medalha em concursos cervejeiros', label: 'Prêmio / medalha em concursos cervejeiros' },
        { value: 'recomendações de amigos', label: 'Recomendações de amigos' },
        { value: 'recomendações de especialistas', label: 'Recomendações de especialistas' },
        { value: 'rótulo (visual)', label: 'Rótulo (visual)' },
      ];
      if(allAnswers['common-beer'] == 'somente comuns') {
        return options.filter((option) => {
          return (
            option.value !== 'prêmio / medalha em concursos cervejeiros' &&
            option.value !== 'escola/origem (alemã, inglesa, belga, americana)' &&
            option.value !== 'harmonização com pratos' &&
            option.value !== 'marcas desconhecidas (desbravando)' &&
            option.value !== 'recomendações de especialistas'
          );
        });
      }
      return options;
    },
    minSelections: 1,
    maxSelections: 3,
    validation: validations.checkboxMinMax(1, 3),
  },
  {
    id: 'beer-adquisition-packaging',
    question: 'Qual tipo de embalagem você prefere para sua cerveja?',
    type: 'radio',
    options: [
      { value:'longneck', label: 'Longneck' },
      { value:'lata', label: 'Lata' },
      { value:'latão', label: 'Latão' },
      { value:'garrafa 600ml', label: 'Garrafa 600ml' },
      { value:'litrão ', label: 'Litrão ' },
    ],
    validation: validations.required
  }
];
